const constantJs = {
  inch2cm: 2.54,
  dashLineColor: '#999999',
  rectLineColor: '#525977',
  catchAreaColor: '#fbfcb5',
  blackAreaColor: 'rgba(0, 0, 0, 0.5)',
  helpLineColor: '#999999',
  roomLineColor: '#666666',
  roomFillColor: 'rgba(214, 214, 214, 0.5)',
  cornerAreaColor: 'rgba(139, 162, 152, 0.5)',
  rectFillColor: '#FF66FF',
  catchFillColor: 'rgba(255, 178, 217, 1)',
  helpColor: '#409eff',
  helpTextColor: '#130c0e',
  DarkThemeHelpTextColor: '#ffffff',
  get curvedHelpTextColor () {
    // 颜色值由 CSS 变量 --help-text-color 提供，随主题（body.body-dark）切换而变化
    const color = getComputedStyle(document.body).getPropertyValue('--curved-help-text-color').trim()
    return color || '#130c0e'
  },
  avlRangeColor: 'rgba(0, 90, 188, 0.2)',
  dashRemainLineColor: '#DC143C',
  canvasBgColor: 'rgba(214, 214, 214, 0)',
  avageBlendColor: '#575E78',
  rectLineWidth: 1.3,
  screenLineWidth: 2.5,
  helpLineWidth: 0.8,
  arrowAngle: 150,
  edgeScreessColor: 'rgba(251, 252, 148, 0.5)',
  get arrowColor () {
    const color = getComputedStyle(document.body).getPropertyValue('--arrow-color').trim()
    return color || '#10218B'
  },
  PROJECTSPEC_CATEGORY_UST: 4,
  PROJECTSPEC_CATEGORY_HOME: 5,
  PROJECTSPEC_TYPE_UST: 1,
  arrowColorGreen:'rgb(0, 180, 50)',
  rectColorOrange:'rgba(255, 241, 203, 0.5)',
  greenColor:'#00ff00',
  redColor:'#ff0000',
  proArcLengthColor:'rgba(0, 186, 227)',
  blendArcLengthColor:'rgba(117, 47, 157)',
  blendAngleColor:'rgba(64, 115, 201)',
  allArcLengthColor:'rgba(155, 174, 78)',
  proDistanceColor:'rgba(255, 0, 0)',
  radiusColor:'rgba(255, 127, 0)',
}

export default constantJs



// WEBPACK FOOTER //
// ./src/common/constant.js